import { message } from "antd";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import {
  getParticipantesEntregas,
  getOrganizacionesEntregas
} from "../../../../services/financiero/participantesEntregasService";

function agregarTitulo(worksheet, texto, totalColumnas) {
  worksheet.mergeCells(1, 1, 1, totalColumnas);
  const title = worksheet.getCell(1, 1);
  title.value = texto;
  title.font = {
    size: 16,
    bold: true,
    color: { argb: "FFFFFFFF" }
  };
  title.alignment = {
    horizontal: "center",
    vertical: "middle"
  };
  title.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF002060" }
  };
}

function estilarEncabezado(worksheet) {
  const headerRow = worksheet.getRow(2);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1F4E78" }
    };
    cell.alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" }
    };
  });
}

function aplicarBordes(worksheet, totalColumnas) {
  const totalFilas = worksheet.rowCount;
  for (let i = 1; i <= totalFilas; i++) {
    const row = worksheet.getRow(i);
    for (let j = 1; j <= totalColumnas; j++) {
      const cell = row.getCell(j);
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    }
  }
}

function construirHojaParticipantes(workbook, datos) {
  const worksheet = workbook.addWorksheet("Participantes");
  const totalColumnas = 24;
  agregarTitulo(worksheet, "REPORTE DE PARTICIPANTES Y ENTREGAS", totalColumnas);
  worksheet.columns = [
    { key: "codigo_proyecto", width: 12 },
    { key: "nombre_proyecto", width: 30 },
    { key: "subregion_pdet", width: 25 },
    { key: "departamento", width: 16 },
    { key: "municipio", width: 16 },
    { key: "tipo_zona", width: 18 },
    { key: "nombre_zona", width: 25 },
    { key: "quien_ejecuta", width: 20 },
    { key: "nombre_participante", width: 30 },
    { key: "tipo_identificacion", width: 22 },
    { key: "numero_identificacion", width: 18 },
    { key: "sexo", width: 10 },
    { key: "fecha_nacimiento", width: 18 },
    { key: "linea_economica_principal", width: 28 },
    { key: "nivel_escolaridad", width: 25 },
    { key: "organizacion", width: 25 },
    { key: "estado_participante", width: 18 },
    { key: "numero_po", width: 18 },
    { key: "cod_producto", width: 14 },
    { key: "nombre_producto", width: 35 },
    { key: "numero_acta_entrega", width: 22 },
    { key: "cantidad_entregada", width: 18 },
    { key: "valor_total_entregado", width: 22 },
    { key: "estado_entrega", width: 18 }
  ];
  worksheet.getRow(2).values = [
    "Código Proyecto",
    "Nombre del Proyecto",
    "Subregión PDET",
    "Departamento",
    "Municipio",
    "Tipo de Zona",
    "Zona de Influencia",
    "Implementador",
    "Nombre del Participante",
    "Tipo de Identificación",
    "Número de Identificación",
    "Sexo",
    "Fecha de Nacimiento",
    "Línea Económica",
    "Nivel de Escolaridad",
    "Organización del Participante",
    "Estado del Participante",
    "Número de PO",
    "Cód. Producto",
    "Nombre del Producto",
    "N° Acta de Entrega",
    "Cantidad Entregada",
    "Valor Total Entregado (COP)",
    "Estado de la Entrega"
  ];
  estilarEncabezado(worksheet);
  datos.forEach((row) => {
    const newRow = worksheet.addRow({
      ...row,
      fecha_nacimiento: row.fecha_nacimiento
        ? dayjs(row.fecha_nacimiento).format("YYYY-MM-DD")
        : "",
      cantidad_entregada: Number(row.cantidad_entregada),
      valor_total_entregado: Number(row.valor_total_entregado)
    });
    newRow.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        wrapText: true
      };
    });
  });
  worksheet.getColumn("valor_total_entregado").numFmt = '"$"#,##0';
  worksheet.views = [{ state: "frozen", ySplit: 2 }];
  aplicarBordes(worksheet, totalColumnas);
}

function construirHojaOrganizaciones(workbook, datos) {
  const worksheet = workbook.addWorksheet("Organizaciones");
  const totalColumnas = 17;
  agregarTitulo(worksheet, "REPORTE DE ORGANIZACIONES Y ENTREGAS", totalColumnas);
  worksheet.columns = [
    { key: "codigo_proyecto", width: 12 },
    { key: "nombre_proyecto", width: 30 },
    { key: "subregion_pdet", width: 25 },
    { key: "departamento", width: 16 },
    { key: "municipio", width: 16 },
    { key: "quien_ejecuta", width: 20 },
    { key: "nombre_organizacion", width: 32 },
    { key: "sigla_organizacion", width: 14 },
    { key: "nit_organizacion", width: 18 },
    { key: "tipo_organizacion", width: 20 },
    { key: "numero_po", width: 18 },
    { key: "cod_producto", width: 14 },
    { key: "nombre_producto", width: 35 },
    { key: "numero_acta_entrega", width: 22 },
    { key: "cantidad_entregada", width: 18 },
    { key: "valor_total_entregado", width: 22 }
  ];
  worksheet.getRow(2).values = [
    "Código Proyecto",
    "Nombre del Proyecto",
    "Subregión PDET",
    "Departamento",
    "Municipio",
    "Implementador",
    "Nombre de la Organización",
    "Sigla",
    "NIT",
    "Tipo de Organización",
    "Número de PO",
    "Cód. Producto",
    "Nombre del Producto",
    "N° Acta de Entrega",
    "Cantidad Entregada",
    "Valor Total Entregado (COP)"
  ];
  estilarEncabezado(worksheet);
  datos.forEach((row) => {
    const newRow = worksheet.addRow({
      ...row,
      cantidad_entregada: Number(row.cantidad_entregada),
      valor_total_entregado: Number(row.valor_total_entregado)
    });
    newRow.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        wrapText: true
      };
    });
  });
  worksheet.getColumn("valor_total_entregado").numFmt = '"$"#,##0';
  worksheet.views = [{ state: "frozen", ySplit: 2 }];
  aplicarBordes(worksheet, totalColumnas);
}

export const exportarParticipantesEntregasExcel = async (proyectos = []) => {
  try {
    const [participantes, organizaciones] = await Promise.all([
      getParticipantesEntregas(proyectos),
      getOrganizacionesEntregas(proyectos)
    ]);

    if (!participantes.length && !organizaciones.length) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    if (participantes.length) construirHojaParticipantes(workbook, participantes);
    if (organizaciones.length) construirHojaOrganizaciones(workbook, organizaciones);

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `Reporte_Participantes_Organizaciones_Entregas_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
    );
  } catch (error) {
    console.error(error);
    message.error("Error generando exportable");
  }
};
